import { render, staticRenderFns } from "./DiscussionDrawer.vue?vue&type=template&id=3833fb39&scoped=true&"
import script from "./DiscussionDrawer.vue?vue&type=script&lang=js&"
export * from "./DiscussionDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionDrawer.vue?vue&type=style&index=0&id=3833fb39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833fb39",
  null
  
)

export default component.exports